export const TEXT_KEYS = {
    LEGAL_TAGLINE: 'platform-selection__disclaimer'
};
